import {  Dispatch, SetStateAction, useRef, useState } from "react";
import GrSystem from "./GrSystem";
import FaQuestionCircle from "./FaQuestionCircle";
import { useTranslation } from "react-i18next";
import Tooltip from "./Tooltip";

export default function ForceSystemTheme({ 
    forceSystemTheme,
    setForceSystemTheme,
}: { 
    forceSystemTheme: boolean;
    setForceSystemTheme: Dispatch<SetStateAction<boolean>>;
}) {
    const tooltipButtonRef = useRef<HTMLButtonElement>(null);
    const [showTooltip, setShowTooltip] = useState(false);
    const { t } = useTranslation();

    return (
        <div className="flex justify-between items-center flex-col xs:flex-row gap-[0.1rem] xs:gap-0 whitespace-nowrap w-full font-size-from-base-to-2xl">
            <div className="relative flex justify-between items-center flex-row gap-[0.3rem] 2xl:gap-[0.5vw] whitespace-nowrap">
                <p className="m-0 leading-none">
                    {t("navBarItems.toolsMenu.forceSystemTheme.title")}
                </p>
                <button
                    ref={tooltipButtonRef}
                    type="button"
                    className="text-[80%] text-blue-500 cursor-pointer"
                    onClick={() => setShowTooltip(prev => !prev)}
                    aria-label={t("navBarItems.toolsMenu.forceSystemTheme.tooltip.buttonAriaLabel")}
                    aria-describedby="forceSystemThemeTooltip"
                >
                    <FaQuestionCircle ariaLabel={t("navBarItems.toolsMenu.forceSystemTheme.tooltip.buttonAriaLabel")} />
                </button>

                <Tooltip 
                    showTooltip={showTooltip} 
                    setShowTooltip={setShowTooltip}
                    tooltipButtonpRef={tooltipButtonRef}
                />
            </div>
            
            <button 
                className="flex flex-row justify-center items-center cursor-pointer" 
                onClick={()=>setForceSystemTheme(!forceSystemTheme)}
            >
                <span className="text-[80%] uppercase font-semibold leading-none">
                    {t(`navBarItems.toolsMenu.forceSystemTheme.mode.${forceSystemTheme}`)}
                </span>&nbsp;
                <GrSystem />
            </button>
        </div>
    );
}